import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_URL_BACKEND,
  // timeout: 1000,
  headers: { 'Content-Type': 'application/json' },
  responseType: 'json',
  // withCredentials: true
})

Vue.prototype.$http = axiosIns

export default axiosIns
